import { ComponentProps } from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';

import { mergeClasses } from '@/utils';

interface ILabel extends ComponentProps<typeof LabelPrimitive.Root> {
  required?: boolean;
}

export const Label = ({ className, children, required, ...props }: ILabel) => {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={mergeClasses(
        'flex items-center text-neutral-9 dark:text-neutral-0 text-body-sm font-semibold',
        className,
      )}
      {...props}
    >
      {children}
      {required && <span className="text-semantic-error-base">&nbsp;*</span>}
    </LabelPrimitive.Root>
  );
};
